/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {ContactDtoModel} from './contacts-dto.model';

export class CustomerContactDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  contactDTO: ContactDtoModel | undefined = undefined;
  jobTitleValue: string | undefined = undefined;
  buyingRoleValue: string | undefined = undefined;
  contactTypeValue: string | undefined = undefined;
  neverCall = false;
}
